import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const MESSAGES: Record<string, { title: string; body: string; cta?: { label: string; to: string } }> = {
  'fixed-jobs': {
    title: 'ตารางเฉพาะกิจ (Fixed Jobs) ถูกยกเลิกแล้ว',
    body: 'ระบบตารางประจำย้ายไปใช้ Class Templates แล้ว กรุณาจัดการตารางที่เมนู "ตารางประจำ"',
    cta: { label: 'ไปที่ตารางประจำ', to: '/admin/class-templates' },
  },
  'occurrence-edits': {
    title: 'ขอแก้ไขคาบ (Fixed Jobs) ถูกยกเลิกแล้ว',
    body: 'การขอแก้ไขคาบจากระบบ Fixed Jobs ไม่รองรับอีกต่อไป ครูใช้ Class Template Events ผ่านตารางเรียนแทน',
    cta: { label: 'ไปที่ตารางประจำ', to: '/admin/class-templates' },
  },
  'special-class': {
    title: 'ฟอร์มคลาสพิเศษ (Fixed Jobs) ถูกยกเลิกแล้ว',
    body: 'การบันทึกคลาสพิเศษผ่าน Fixed Jobs ไม่รองรับอีกต่อไป กรุณาใช้ตารางเรียนจาก Class Templates',
    cta: { label: 'ไปที่ตารางเรียน', to: '/teacher-schedule' },
  },
};

export default function DeprecatedFeaturePage({ feature }: { feature: keyof typeof MESSAGES }) {
  const msg = MESSAGES[feature] ?? MESSAGES['fixed-jobs'];

  return (
    <div className="container mx-auto max-w-lg py-16 px-4">
      <Card>
        <CardHeader>
          <CardTitle>{msg.title}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">{msg.body}</p>
          {msg.cta && (
            <Button asChild>
              <Link to={msg.cta.to}>{msg.cta.label}</Link>
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
